
import React from "react";
import { Classname } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IProfileWebsite, ITournamentEditionMatch } from "../../../../../services";

export interface MatchRowProps {
    publicId: string;
    website: IProfileWebsite;
    match: ITournamentEditionMatch;
}

function MatchRow({ publicId, website, match: t }: MatchRowProps) {

    const labels = i18nManager.Labels.schedule;
    const ownScores = Object.values(Object.values(t.scores ?? {})?.[0] ?? {}).map((s) => Object.values(s)?.[0]);
    const won = (ownScores?.[0] ?? 0) > ownScores?.[1];
    const [first, ...others] = (t.tournament_edition_registered_participant_ids ?? []).map((external_id) => ({ ...t.extra_data?.participants_profiles?.[external_id], external_id }));
    const flattenedOwnMembers = JSON.stringify(t.extra_data?.participants_profiles?.[first?.external_id + "_members"]);
    const isHome = (first?.external_id === website.member.external_id || first?.username === website.member.username)
        || (flattenedOwnMembers?.includes(website.member.external_id) || flattenedOwnMembers?.includes(website.member.username));
    const ended = t.status === "ENDED";

    return (<a className={styles["match"]} target="_blank" rel="noreferrer" href={Utils.buildTournamentMatchLink(publicId, t)}>
        <div className={Classname.build(styles["match-dot"], {
            [styles["dot-ongoing"]]: t.status === "ONGOING",
            [styles["dot-upcoming"]]: t.status === "UPCOMING",
            [styles["dot-win"]]: ended && won,
            [styles["dot-loss"]]: ended && !won,
        })} />
        <div className={styles["match-date"]}>{Utils.fineDate(new Date(t.start_date))}</div>
        <div className={styles["match-sides"]}>
            {first && (<span className={styles["match-side"]}>
                <img alt={first.external_id} src={first.profile_picture_url ?? first.logo_url} />
                <span>{first.name ?? first.username}</span>
            </span>)}
            {(others.length > 0) && (<span className={styles["match-vs"]}>vs</span>)}
            {others.map((other: any, index: number) => (<span key={other.external_id} className={styles["match-side"]}>
                <img alt={other.external_id} src={other.profile_picture_url ?? other.logo_url} />
                <span>{other.name ?? other.username}{index < others.length - 1 ? "," : ""}</span>
            </span>))}
        </div>
        <div className={styles["match-comp"]}>{t.tournament_edition?.name}</div>
        <div className={styles["match-hoa"]}>{isHome ? labels.home : labels.away}</div>
        <div className={Classname.build(styles["match-score"], {
            [styles["score-win"]]: t.status === "ONGOING" || (ended && won),
            [styles["score-loss"]]: ended && !won,
        })}>
            {ownScores.length ? `${ownScores[0] ?? ""} - ${ownScores.slice(1).join(", ")}` : (t.status === "UPCOMING" ? labels.tbd : "-")}
        </div>
    </a>);
}

export default MatchRow;
